export const MAX_NAME_LENGTH = 30
export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 72
export const MAX_EMAIL_LENGTH = 254
export const MAX_VAR_CHAR_LENGTH = 255
